import { createSlice } from "@reduxjs/toolkit";
import { getCookie, setCookie } from "../../../utils/storage";

const initialState = {
  packages: getCookie("packages") ? JSON.parse(getCookie("packages")) : [],
  selectedPackages: getCookie("selectedPackages")
    ? JSON.parse(getCookie("selectedPackages"))
    : [],
};

export const packagesSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    addPackages: (state, { payload }) => {
      state.packages = payload;
      setCookie("packages", payload);

      if (payload?.length >= 1 && state.selectedPackages?.length === 0) {
        state.selectedPackages = [payload[0]?.product_id];
        setCookie("selectedPackages", [payload[0]?.product_id]);
      }
    },

    setSelectedPackages: (state, { payload }) => {
      state.selectedPackages = payload;
      setCookie("selectedPackages", payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const { addPackages, setSelectedPackages } = packagesSlice.actions;

export default packagesSlice.reducer;
